import { render, staticRenderFns } from "./StockViewModal.vue?vue&type=template&id=84ceba20&"
import script from "./StockViewModal.vue?vue&type=script&lang=js&"
export * from "./StockViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports